import { useState } from 'react'

interface TeamMemberSelection {
  selectedTeamId: string | null
  selectedUserId: string | null  // Changed to string for UUID
  selectedUserIds: string[]  // Changed to string array for UUIDs
  setSelectedTeamId: (teamId: string | null) => void
  setSelectedUserId: (userId: string | null) => void  // Changed to string for UUID
  setSelectedUserIds: (userIds: string[]) => void  // Changed to string array for UUIDs
  resetSelection: () => void
  hasTeamSelected: boolean
  hasUserSelected: boolean
  hasUsersSelected: boolean
  getSelectedCount: () => number
}

/**
 * Custom hook for managing team member selection state
 * Provides convenient state management for TeamMemberSelector component
 */
export function useTeamMemberSelection(): TeamMemberSelection {
  const [selectedTeamId, setSelectedTeamId] = useState<string | null>(null)
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null)  // Changed to string for UUID
  const [selectedUserIds, setSelectedUserIds] = useState<string[]>([])  // Changed to string array for UUIDs

  const resetSelection = () => {
    setSelectedTeamId(null)
    setSelectedUserId(null)
    setSelectedUserIds([])
  }

  const hasTeamSelected = selectedTeamId !== null
  const hasUserSelected = selectedUserId !== null
  const hasUsersSelected = selectedUserIds.length > 0
  const getSelectedCount = () => selectedUserIds.length

  return {
    selectedTeamId,
    selectedUserId,
    selectedUserIds,
    setSelectedTeamId,
    setSelectedUserId,
    setSelectedUserIds,
    resetSelection,
    hasTeamSelected,
    hasUserSelected,
    hasUsersSelected,
    getSelectedCount
  }
}
